﻿import * as $ from "jquery";
import "materialize-css";

$(() => {
    $("select").material_select();
    $(".dropdown-button").dropdown({
        belowOrigin: true
    });

    $('#selectedCulture').change(function () {
        this.form.submit();
    });
    Materialize.updateTextFields();
});

$('.carousel.carousel-slider').carousel({ fullWidth: true });

$(document).ready(function () {
    var header = $('.backgroundCarousel');

    var backgrounds = new Array(
        'url(../images/pro-plus-img-1.jpg)',
        'url(../images/pro-plus-img-2.jpg)',
        'url(../images/pro-plus-img-3.jpg)',
        'url(../images/pro-plus-img-4.jpg)'
    );

    var current = 0;

    function nextBackground() {
        current++;
        current = current % backgrounds.length;
        header.css({
            'background-image': backgrounds[current],
            'background-size': 'cover',
            'background-repeat': 'no-repeat',
            'background-position': 'left top',
            'min-height': '100 %',
            'min-width': '100 %',
            'width': 'auto',
            'height': 'auto - 64px',
            'position': 'fixed',
            'top': '64px',
            'left': '0',
            'z-index': '-500'
        });        
    }
    setInterval(nextBackground, 5000);

    //header.css('background-image', backgrounds[0]);

    header.css({
        'background-image': backgrounds[0],
        'background-size': 'cover',
        'background-repeat': 'no-repeat',
        'background-position': 'left top',
        'min-height': '100 %',
        'min-width': '100 %',
        'width': 'auto',
        'height': 'auto - 64px',
        'position': 'fixed',
        'top': '64px',
        'left': '0',
        'z-index': '-500'
    });  
});
